import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiFetch } from '../../api/api';

export default function PrinterGroupsTab() {
  const [groups, setGroups] = useState([]);
  const [newGroup, setNewGroup] = useState({ name: '', description: '' });
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [editingValues, setEditingValues] = useState({});

  useEffect(() => {
    loadGroups();
  }, []);

  

  async function loadGroups() {
    try {
      const res = await apiFetch('/api/printmanager/printergroups');
      setGroups(res || []);
    } catch (err) {
      console.error(err);
      toast.error('Failed to load printer groups');
    }
  }

  async function createGroup() {
    try {
      const res = await apiFetch('/api/printmanager/printergroups', {
        method: 'POST',
        body: newGroup,
      });
      toast.success('Group created');
      setNewGroup({ name: '', description: '' });
      loadGroups();
    } catch {
      toast.error('Failed to create group');
    }
  }

  async function deleteGroup(printerGroupId) {
    if (!window.confirm('Are you sure you want to delete this group?')) return;
    try {
      await apiFetch(`/api/printmanager/printergroups/${printerGroupId}`, { method: 'DELETE' });
      toast.success('Group deleted');
      loadGroups();
    } catch {
      toast.error('Failed to delete group');
    }
  }

  async function saveEdit(printerGroupId) {
    try {
      await apiFetch(`/api/printmanager/printergroups/${printerGroupId}`, {
        method: 'PATCH',
        body: editingValues,
      });
      toast.success('Group updated');
      setEditingGroupId(null);
      setEditingValues({});
      loadGroups();
    } catch {
      toast.error('Failed to update group');
    }
  }

  return (
    <div className="printer-groups-tab">
      <h2>Printer Groups</h2>

      <table className="pm-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Rules</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {groups.map(g => (
            <tr key={g._id}>
              <td>
                {editingGroupId === g._id ? (
                  <input
                    value={editingValues.name || ''}
                    onChange={e => setEditingValues(v => ({ ...v, name: e.target.value }))}
                  />
                ) : (
                  g.name
                )}
              </td>
              <td>
                {editingGroupId === g._id ? (
                  <input
                    value={editingValues.description || ''}
                    onChange={e => setEditingValues(v => ({ ...v, description: e.target.value }))}
                  />
                ) : (
                  g.description || '—'
                )}
              </td>
              <td>
                {g.rules?.mediaType || '—'}
              </td>
              <td>
                {editingGroupId === g._id ? (
                  <>
                    <button onClick={() => saveEdit(g._id)}>💾 Save</button>
                    <button onClick={() => setEditingGroupId(null)}>❌ Cancel</button>
                  </>
                ) : (
                  <>
                    <button onClick={() => {
                      setEditingGroupId(g._id);
                      setEditingValues({ name: g.name, description: g.description });
                    }}>✏️ Edit</button>
                    <button onClick={() => deleteGroup(g._id)}>🗑 Delete</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>Create New Group</h3>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <input
          placeholder="Group Name"
          value={newGroup.name}
          onChange={e => setNewGroup(v => ({ ...v, name: e.target.value }))}
        />
        <input
          placeholder="Description"
          value={newGroup.description}
          onChange={e => setNewGroup(v => ({ ...v, description: e.target.value }))}
        />
        <button onClick={createGroup}>➕ Add Group</button>
      </div>
    </div>
  );
}
